export default {"src":"/_next/static/media/0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c.befa118b.svg","height":4092,"width":4091,"blurWidth":0,"blurHeight":0};